class Conversation {
  responses = [];
  answers = [];
  complete = false;

  addResponses = responses => {
    responses.forEach(resp => {
      this.responses.push({
        message: {__html: resp},
        from: 0,
        timestamp: new Date().getTime(),
        order: this.getNextMessageIndex(),
      });
    });
    return this.getSortedConversation();
  };

  addAnswer = answer => {
    this.answers.push({
      message: answer,
      from: 1,
      timestamp: new Date().getTime(),
      order: this.getNextMessageIndex(),
    });
    return this.getSortedConversation();
  };

  restoreConversation = messages => {
    messages.forEach(message => {
      if (message.type == "answer") {
        this.answers.push({
          message: message.content,
          from: 1,
          timestamp: new Date().getTime(),
          order: this.getNextMessageIndex(),
        });
      } else {
        this.responses.push({
          message: {__html: message.content},
          from: 0,
          timestamp: new Date().getTime(),
          order: this.getNextMessageIndex(),
        });
      }
    });

    return this.getSortedConversation();
  };

  getNextMessageIndex = () => {
    return this.answers.length + this.responses.length;
  };

  getConversation = () => ({
    responses: this.responses,
    answers: this.answers,
    complete: this.complete,
  });

  getSortedConversation = () => {
    return {
      complete: this.complete,
      messages: [
        ...this.responses,
        ...this.answers,
      ].sort((a, b) => a.order - b.order),
    };
  };

  resetConversation = () => {
    this.responses = [];
    this.answers = [];
    this.complete = false;
  };
};

const c = new Conversation();

export default c;
